import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CompareContext = createContext(null);

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("lmc_compare") || "[]"));

  useEffect(() => {
    localStorage.setItem("lmc_compare", JSON.stringify(items));
  }, [items]);

  const toggle = useCallback((college) => {
    setItems((prev) => {
      const exists = prev.find((c) => c.slug === college.slug);
      if (exists) return prev.filter((c) => c.slug !== college.slug);
      if (prev.length >= 3) return prev;
      return [...prev, { slug: college.slug, name: college.short_name || college.name }];
    });
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((c) => c.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);
  const has = useCallback((slug) => items.some((c) => c.slug === slug), [items]);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, has }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
